<template>
  <section class="login flex flex-center">
    <ba-card>
      <template slot="header">
        <span>Se connecter</span>
      </template>
      <template>
        <form @submit.prevent="handleLogin">
          <div class="login-container flex flex-space">
            <div class="logo-container">
              <img src="/img/logo.png">
            </div>
            <div>
              <ba-input
                id="email"
                v-model.trim="email"
                type="text"
                label="Email"
                class="mandatory"
              />
              <ba-input
                id="password"
                v-model.trim="password"
                type="password"
                label="Mot de passe"
                class="mandatory"
                iconset="login"
                password-reveal
              />
              <div class="buttons-container flex flex-space">
                <span @click="showModal">Mot de passe oublié</span>
                <ba-button class="primary">
                  Se connecter
                </ba-button>
              </div>
            </div>
          </div>
        </form>
      </template>
    </ba-card>

    <modal
      class="modal"
      name="resetPassword"
      width="376px"
    >
      <form @submit.prevent="handleResetPassword">
        <ba-card>
          <template slot="header">
            <span>Mot de passe oublié</span>
          </template>
          <template>
            <p>Merci de saisir l'adresse email associée à votre compte</p>
            <ba-input
              id="reset"
              v-model="resetEmail"
              type="text"
              label="Email"
              class="mandatory"
            />
            <p>Vous recevrez un email vous invitant à le réinitialiser</p>
          </template>
          <template slot="footer">
            <div class="buttons-container flex flex-space">
              <ba-button
                type="button"
                class="primary"
                @click.native="closeModal"
              >
                Annuler
              </ba-button>
              <ba-button class="primary">
                Valider
              </ba-button>
            </div>
          </template>
        </ba-card>
      </form>
    </modal>

    <modal
      class="modal"
      name="resetExpiredPassword"
      width="400px"
      height="auto"
    >
      <form @submit.prevent="handleResetExpiredPassword">
        <ba-card>
          <template slot="header">
            <span>Changement de mot de passe</span>
          </template>
          <template>
            <p class="col-6 text-center">
              Suite à votre première connexion ou à l'éxpiration de votre mot de passe après 90jours, il est nécessaire que vous le modifiez.
            </p>
            <div class="col-3">
              <ba-input
                v-model.trim="passwordUpdate.new_pwd"
                type="password"
                class="mandatory"
                label="Nouveau mot de passe"
              />
            </div>
            <div class="col-3">
              <ba-input
                v-model.trim="passwordUpdate.confirm_pwd"
                type="password"
                class="mandatory"
                label="Confirmation nouveau mot de passe"
              />
            </div>
          </template>
          <template slot="footer">
            <div class="buttons-container flex flex-end">
              <ba-button
                class="primary"
              >
                Valider
              </ba-button>
            </div>
          </template>
        </ba-card>
      </form>
    </modal>

    <modal class="modal" name="acceptTerms" width="400px" height="auto">
      <ba-card>
        <template slot="header">
          <span>Conditions d'utilisation et Mentions légales</span>
        </template>
        <template>
          <div style="padding: 1rem 2rem;">
            <label>
              <input type="checkbox" v-model="termsAccepted" />
              J'accepte les <a href="/terms" target="_blank">Conditions Générales d'Utilisation</a>
              et la <a href="/privacy" target="_blank">Politique de Confidentialité</a>
            </label>
          </div>
        </template>
        <template slot="footer">
          <div class="buttons-container flex flex-end">
            <ba-button class="primary" :disabled="!termsAccepted" @click.native="confirmTermsConds">
              Valider
            </ba-button>
          </div>
        </template>
      </ba-card>
    </modal>

    <ab-iconset iconset="login">
      <g id="eye">
        <path d="M12 5C7 5 2.73 8.11 1 12.5C2.73 16.89 7 20 12 20C17 20 21.27 16.89 23 12.5C21.27 8.11 17 5 12 5ZM12 17.5C9.24 17.5 7 15.26 7 12.5C7 9.74 9.24 7.5 12 7.5C14.76 7.5 17 9.74 17 12.5C17 15.26 14.76 17.5 12 17.5ZM12 9.5C10.34 9.5 9 10.84 9 12.5C9 14.16 10.34 15.5 12 15.5C13.66 15.5 15 14.16 15 12.5C15 10.84 13.66 9.5 12 9.5Z" />
      </g>
      <g id="eye-close">
        <path d="M12 7C14.76 7 17 9.24 17 12C17 12.65 16.87 13.26 16.64 13.83L19.56 16.75C21.07 15.49 22.26 13.86 22.99 12C21.26 7.61 16.99 4.5 11.99 4.5C10.59 4.5 9.25 4.75 8.01 5.2L10.17 7.36C10.74 7.13 11.35 7 12 7ZM2 4.27L4.28 6.55L4.74 7.01C3.08 8.3 1.78 10.02 1 12C2.73 16.39 7 19.5 12 19.5C13.55 19.5 15.03 19.2 16.38 18.66L16.8 19.08L19.73 22L21 20.73L3.27 3L2 4.27ZM7.53 9.8L9.08 11.35C9.03 11.56 9 11.78 9 12C9 13.66 10.34 15 12 15C12.22 15 12.44 14.97 12.65 14.92L14.2 16.47C13.53 16.8 12.79 17 12 17C9.24 17 7 14.76 7 12C7 11.21 7.2 10.47 7.53 9.8V9.8ZM11.84 9.02L14.99 12.17L15.01 12.01C15.01 10.35 13.67 9.01 12.01 9.01L11.84 9.02Z" />
      </g>
    </ab-iconset>
  </section>
</template>

<script>
import {
  AbIcon, AbIconset, BaButton, BaCard, BaInput
} from '@ab/basic-components';

export default {
  name: 'Login',
  components: {
    AbIcon,
    AbIconset,
    BaButton,
    BaCard,
    BaInput
  },
  data() {
    return {
      passwordUpdate: {
        new_pwd: '',
        confirm_pwd: ''
      },
      email: '',
      password: '',
      resetEmail: '',
      termsAccepted: false,
      userData: null,
    };
  },
  methods: {
    async handleLogin() {
      const email = this.$el.querySelector('#email input');
      const password = this.$el.querySelector('#password input');

      if (this.email != '' && this.password != '') {
        const data = await this.$store.dispatch('login', {
          email: this.email,
          password: this.password.replaceAll('?', '‰‰')
        });
        if (data.resetToken) {
          this.resetToken = data.resetToken;
          return this.$modal.show('resetExpiredPassword');
        }

        if (data && data.user && !data.user.hasAcceptedTerms) {
          this.userData = data;
          this.termsAccepted = false;
          return this.$modal.show('acceptTerms');
        }

        await this.$store.dispatch('loginUserData', data);

        if (data && data.token) {
          this.$store.dispatch('displaySnackbar', { text: 'Bienvenue', mode: '' });

          this.$store.commit('setUserRole', data.user.role_id);
          this.$store.commit('setAllDetailRole', data.user.allDetailRole);
          return data.user.role_id === 3 ? this.$router.push({ name: 'DocumentList' }) : this.$router.push({ name: 'Dashboard' });
        }
        // Clear password field when incorrect credentials
        this.password = '';
      } else {
        if (!this.email) email.classList.add('error');
        if (!this.password) password.classList.add('error');
        this.$store.dispatch('displaySnackbar', {
          text: 'Veuillez remplir les champs obligatoires',
          mode: 'error'
        });
      }
    },
    showModal() {
      this.$modal.show('resetPassword');
    },
    closeModal() {
      this.$modal.hide('resetPassword');
    },
    async handleResetExpiredPassword() {
      if (this.passwordUpdate.new_pwd && this.passwordUpdate.confirm_pwd) {
        if ((!this.passwordUpdate.new_pwd.match(/^(?=.*[A-Za-z])(?=.*\d)(?=.*[@$!%*#?&+=.;_{}<>|^£:"'])[A-Za-z\d@$!%*#?&+=.;_{}<>|^£:"']{8,}$/)) || (!this.passwordUpdate.confirm_pwd.match(/^(?=.*[A-Za-z])(?=.*\d)(?=.*[@$!%*#?&+=.;_{}<>|^£:"'])[A-Za-z\d@$!%*#?&+=.;_{}<>|^£:"']{8,}$/))) {
          this.$store.dispatch('displaySnackbar', { text: "Votre mot de passe doit contenir au moins 8 caractères dont 1 lettre 1 chiffre et 1 caractère spécial", mode: '' });
          return;
        }
        if (this.passwordUpdate.new_pwd == this.passwordUpdate.confirm_pwd) {
          const data = await this.$store.dispatch('changePassword', {
            token: this.resetToken,
            password: this.passwordUpdate.new_pwd.replaceAll('?', '‰‰'),
            passwordConfirm: this.passwordUpdate.confirm_pwd.replaceAll('?', '‰‰'),
          });
          if (data && data.success) {
            this.$store.dispatch('displaySnackbar', { text: "Votre mot de passe a été réinitialisé", mode: '' });
            this.$modal.hide('resetExpiredPassword');
          }
        } else {
          this.$store.dispatch('displaySnackbar', {
            text: "Les champs entrés ne sont pas identiques. Veuillez réessayer",
            mode: 'error'
          });
        }
      } else {
        this.$store.dispatch('displaySnackbar', {
          text: "Veuillez remplir les champs obligatoires",
          mode: 'error'
        });
      }
    },
    handleResetPassword() {
      const reset = this.$el.querySelector('#reset');

      if (this.resetEmail) {
        this.$store.dispatch('requestPwdChange', { email: this.resetEmail });
        this.$store.dispatch('displaySnackbar', { text: "Un e-mail a été envoyé à l'adresse indiquée", mode: '' });
        this.closeModal();
      } else {
        this.$store.dispatch('displaySnackbar', {
          text: 'Veuillez entrer un e-mail valide',
          mode: 'error'
        });
      }
      this.resetEmail = '';
    },
    async confirmTermsConds() {
      if (this.userData) {
        const data = await this.$store.dispatch('setAcceptTermsConds', {
          ...this.userData.user
        });

        this.$modal.hide('acceptTerms');
        if (data) {
          await this.$store.dispatch('loginUserData', this.userData);
          this.$store.dispatch('displaySnackbar', { text: 'Conditions acceptées, bienvenue', mode: '' });
          this.$store.commit('setUserRole', this.userData.user.role_id);
          this.$store.commit('setAllDetailRole', this.userData.user.allDetailRole);
          this.$router.push(
            this.userData.user.role_id === 3
              ? { name: 'DocumentList' }
              : { name: 'Dashboard' }
          );
          this.userData = null;
        }
      }
    },
  }
};
</script>

<style scoped>
.login { height: 100%; }
.login main{
  font-size: 0.79rem;
}

.login .login-container > div {
  margin: 0 2rem;
}
.login .login-container .ba-input {
  min-width: 22rem;
  margin-bottom: 2.5rem;
}
.login .logo-container {
  height: 15rem;
  width: 20rem;
}
.login .logo-container img {
  object-fit: contain;
  display: block;
  height: 100%;
  width: 100%;
}
.login .buttons-container span {
  font-size: 0.79rem;
  text-decoration: underline;
  cursor: pointer;
}

/* Modal */
.login .modal main .ba-input {
  margin: 2rem auto;
  width: 18.1rem;
}
</style>
<style>
.login .login-container .ab-icon { color: var(--app-primary-color); }
.login .login-container .icon-button { top: -2px; }

/* Modal */
#app .login .modal .ba-card main {
  font-size: 0.79rem;
  padding: 2rem 0;
}
.login .modal main p { text-align: center; }
.login .modal .ba-card footer {
  padding: 0 3.6rem 1.4rem 3.6rem;
}
</style>
<style src="@/assets/styles/modals.css"></style>
